/**
 * BetaFeedbackBadge Component
 * Displays beta feedback counts (positive/negative) for games in beta channel
 */

import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import {
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon
} from '@mui/icons-material';

export const BetaFeedbackBadge = ({ positiveCount = 0, negativeCount = 0 }) => {
  const total = positiveCount + negativeCount;

  if (total === 0) {
    return (
      <Chip
        label="No feedback"
        size="small"
        variant="outlined"
        sx={{ color: 'text.secondary' }}
      />
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <Tooltip title={`${positiveCount} positive feedback${positiveCount !== 1 ? 's' : ''}`}>
        <Chip
          icon={<ThumbUpIcon sx={{ fontSize: 14 }} />}
          label={positiveCount}
          size="small"
          color="success"
          variant={positiveCount > 0 ? 'filled' : 'outlined'}
        />
      </Tooltip>
      <Tooltip title={`${negativeCount} issue${negativeCount !== 1 ? 's' : ''} reported`}>
        <Chip
          icon={<ThumbDownIcon sx={{ fontSize: 14 }} />}
          label={negativeCount}
          size="small"
          color="error"
          variant={negativeCount > 0 ? 'filled' : 'outlined'}
        />
      </Tooltip>
    </Box>
  );
};

/**
 * Helper to determine if a game is ready for promotion based on feedback
 * Criteria: 20+ positive, 0 negative
 */
export const isReadyForPromotion = (positiveCount, negativeCount) => {
  return positiveCount >= 20 && negativeCount === 0;
};

/**
 * Helper to determine if a game has issues
 * Criteria: any negative feedback
 */
export const hasIssues = (negativeCount) => {
  return negativeCount > 0;
};
